<script setup lang="ts">
import BodyOverlay from "@/components/Ui/Modal/BodyOverlay.vue";
import HeaderModal from "@/components/Ui/Modal/HeaderModal.vue";
import BodyContent from "@/components/Ui/Modal/BodyContent.vue";
import { watch } from 'vue'

const props = defineProps<{
  isOpen: boolean,
  title?: string,
  hideHeader?: boolean,
  class?: string
}>()

const emit = defineEmits(['close'])

watch(() => props.isOpen, (newValue) => {
  if (newValue) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = 'auto'
  }
})
</script>

<template>
  <BodyOverlay :is-open="isOpen" :class="props.class">
    <HeaderModal v-if="!hideHeader" :title="title ?? ''" @close="emit('close')"></HeaderModal>
    <BodyContent>
      <slot/>
    </BodyContent>
  </BodyOverlay>
</template>
